module.exports = __webpack_public_path__ + "img/medal02.8f8790bf.webp";